var classes = {
  "tooltip": "tooltip__qbyG8",
  "wrapper": "wrapper__2C832",
  "danger": "danger__SWjC-",
  "primary": "primary__MLfnU",
  "xxsmall": "xxsmall__xm1wo",
  "xsmall": "xsmall__1GVyC",
  "small": "small__61kBD",
  "medium": "medium__cWMUi",
  "large": "large__KKfY-",
  "xlarge": "xlarge__Dl-Hu",
  "xxlarge": "xxlarge__2OLCi"
};
export { classes as default };